export default __webpack_public_path__ + "static/media/w2.fe7a1490.svg";